const LocalStorageService = {
  get<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  },

  set<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  },

  clear: (): void => localStorage.clear(),

  remove: (key: string): void => localStorage.removeItem(key),
};

export default LocalStorageService;
